import { Header } from '../components/header';
import styled from 'styled-components';

const StyledApp = styled.div``;

export function App() {
  return (
    <StyledApp>
      <Header />
    </StyledApp>
  );
}

export default App;
